export default "__VITE_ASSET__D0JPEA3e__"